export { getWindowDimensions, checkIfMobile } from "./responsiveHelper"
export { dateDecorator } from "./dateDecorator"
export { Pagination } from "./Pagination"

export interface StringMap {
    [key: string]: string
}
